import { render, staticRenderFns } from "./qwik_deliveryagentmastermr.vue?vue&type=template&id=b8316dba&scoped=true&"
import script from "./qwik_deliveryagentmastermr.vue?vue&type=script&lang=js&"
export * from "./qwik_deliveryagentmastermr.vue?vue&type=script&lang=js&"
import style0 from "./qwik_deliveryagentmastermr.vue?vue&type=style&index=0&id=b8316dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8316dba",
  null
  
)

export default component.exports